import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon, DownloadIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioApoyo from './FormularioApoyo';

const TablaApoyos: React.FC = () => {
  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [filtroPrograma, setFiltroPrograma] = useState('');
  const [filtroBeneficiario, setFiltroBeneficiario] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      if (filtroPrograma) params.append('programaId', filtroPrograma);
      if (filtroBeneficiario) params.append('beneficiarioId', filtroBeneficiario);
      if (fechaInicio) params.append('fechaInicio', fechaInicio);
      if (fechaFin) params.append('fechaFin', fechaFin);
      const res = await axiosInstance.get(`/desarrollo-social/apoyos?${params.toString()}`);
      setData(res.data || []);
    } catch {
      setData([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleVer = async (item: any) => {
    try {
      const res = await axiosInstance.get(`/desarrollo-social/apoyos/${item.id}`);
      setSelectedItem(res.data);
    } catch {
      setSelectedItem(item);
    }
    onOpenVer();
  };

  const handleEliminar = async (item: any) => {
    const ok = window.confirm(`Eliminar apoyo ${item.id}?`);
    if (!ok) return;
    try {
      await axiosInstance.delete(`/desarrollo-social/apoyos/${item.id}`);
      fetchData();
    } catch {
      // noop
    }
  };

  const handlePdf = (id: number) => {
    const base = axiosInstance.defaults.baseURL || '';
    window.open(`${base}/desarrollo-social/apoyos/${id}/pdf`, '_blank');
  };

  const handleGuardado = () => {
    onCloseNuevo();
    fetchData();
  };

  const handleExport = (format: 'excel' | 'pdf') => {
    const base = axiosInstance.defaults.baseURL || '';
    const params = new URLSearchParams();
    if (filtroPrograma) params.append('programaId', filtroPrograma);
    if (filtroBeneficiario) params.append('beneficiarioId', filtroBeneficiario);
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);
    params.append('format', format);
    window.open(`${base}/desarrollo-social/reportes/apoyos/export?${params.toString()}`, '_blank');
  };

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Input placeholder="Programa ID" value={filtroPrograma} onChange={(e) => setFiltroPrograma(e.target.value)} size="sm" w="150px" />
          <Input placeholder="Beneficiario ID" value={filtroBeneficiario} onChange={(e) => setFiltroBeneficiario(e.target.value)} size="sm" w="160px" />
          <Input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} size="sm" w="170px" />
          <Input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} size="sm" w="170px" />
          <Button size="sm" onClick={fetchData} variant="outline">Filtrar</Button>
        </HStack>
        <HStack spacing={2}>
          <Button size="sm" leftIcon={<DownloadIcon />} variant="outline" onClick={() => handleExport('excel')}>Excel</Button>
          <Button size="sm" leftIcon={<DownloadIcon />} variant="outline" onClick={() => handleExport('pdf')}>PDF</Button>
          <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
            Nuevo apoyo
          </Button>
        </HStack>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Programa</Th>
              <Th color="white" fontSize="xs">Beneficiario</Th>
              <Th color="white" fontSize="xs">Tipo apoyo</Th>
              <Th color="white" fontSize="xs">Cantidad</Th>
              <Th color="white" fontSize="xs">Fecha</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : data.length === 0 ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              data.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: 'orange.50' }}>
                  <Td>{item.programa?.nombre || item.programaId}</Td>
                  <Td>{item.beneficiario?.nombreCompleto || item.beneficiarioId}</Td>
                  <Td>{item.tipoApoyo}</Td>
                  <Td>{item.cantidadEntregada}</Td>
                  <Td>{item.fechaEntrega ? new Date(item.fechaEntrega).toLocaleDateString('es-MX') : '-'}</Td>
                  <Td>
                    <HStack spacing={1}>
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="purple" variant="outline" onClick={() => handlePdf(item.id)}>PDF</Button>
                      <Button size="xs" colorScheme="red" variant="outline" onClick={() => handleEliminar(item)}>Eliminar</Button>
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Detalle del apoyo</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioApoyo modo="view" data={selectedItem} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Nuevo apoyo</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioApoyo modo="new" onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaApoyos;


